import { useMemo } from 'react'
import { AdId } from '../../../contexts'
import { Container } from './MidBox.styles'
import { Ad } from '../../../sharedComponnets'

export interface IProps {
  index: number
  collapse: boolean
  onRender?: (ev: googletag.events.SlotRenderEndedEvent) => void
}

export const MidBox = ({ index, collapse, onRender }: IProps) => {
  const id = useMemo(() => index && (`Mid_box_${index}` as AdId), [index])

  if (!id) {
    return null
  }
  return (
    <Container data-name={id} key={id}>
      <Ad id={id} collapse={collapse} onRender={onRender} />
    </Container>
  )
}
export default MidBox
